/* eslint-disable react/no-unknown-property */
import React from 'react'
import { Link } from 'gatsby'
import { css } from 'linaria'
import { STYLE } from '~/utils/constant'
import { rem } from '~/utils/helper'

export interface BreadcrumbTypes {
  label: string
  path?: string
}

interface BreadcrumbProps {
  breadcrumb: BreadcrumbTypes[]
}

const breadcrumbStyle = css`
  order: 2;
  margin-top: 144px;
  background: var(--color-background-bluegray50);

  @media screen and (${STYLE.MEDIA.TABLET}) {
    order: 0;
    margin-top: 0;
    margin-top: var(--height-header);
  }

  @media screen and (${STYLE.MEDIA.PC}) {
    margin-top: var(--height-header-pc);
  }

  & > .items {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    max-width: var(--width-max);
    margin-right: auto;
    margin-left: auto;
    padding: 16px 24px 15px 8px;
    font-size: ${rem(12)};
    letter-spacing: 0;
    row-gap: 4px;

    @media screen and (${STYLE.MEDIA.TABLET}) {
      flex-wrap: nowrap;
    }

    @media screen and (${STYLE.MEDIA.PC}) {
      padding-right: 32px;
      padding-left: 16px;
    }
  }

  & > .items > .item {
    padding-left: 16px;
    color: var(--color-text);

    @media screen and (${STYLE.MEDIA.TABLET}) {
      white-space: nowrap;
    }

    &:last-child {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:not(:first-child) {
      position: relative;
      padding-left: 40px;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 4px;
        left: 20px;
        width: 2px;
        height: 8px;
        margin-top: auto;
        margin-bottom: auto;
        transform: rotate(-45deg);
        border-radius: 100px;
        background: var(--color-background);
      }

      &::after {
        content: '';
        position: absolute;
        top: 4px;
        bottom: 0;
        left: 20px;
        width: 2px;
        height: 8px;
        margin-top: auto;
        margin-bottom: auto;
        transform: rotate(45deg);
        border-radius: 100px;
        background: var(--color-background);
      }
    }
  }

  & > .items > .item > .button {
    color: var(--color-text);
    text-decoration: none;
  }

  & > .items > .item > .text,
  & > .items > .item > .button > .text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    @media screen and (${STYLE.MEDIA.TABLET}) {
      display: inline;
    }
  }
`

const BreadcrumbComponent = ({ breadcrumb }: BreadcrumbProps) => {
  return (
    <div className={breadcrumbStyle}>
      <ol className="items" vocab="https://schema.org/" typeof="BreadcrumbList">
        <li className="item" property="itemListElement" typeof="ListItem">
          <Link className="button" property="item" typeof="WebPage" to="/">
            <span className="text" property="name">
              リファレンスチェックのASHIATO
            </span>
          </Link>
          <meta property="position" content="1" />
        </li>
        {breadcrumb.map((item, index) => {
          return item.path ? (
            <li className="item" property="itemListElement" typeof="ListItem" key={index}>
              <Link className="button" property="item" typeof="WebPage" to={item.path}>
                <span className="text" property="name">
                  {item.label}
                </span>
              </Link>
              <meta property="position" content={String(index + 2)} />
            </li>
          ) : (
            <li className="item" property="itemListElement" typeof="ListItem" key={index}>
              <span className="text" id="breadcrumb-pagetitle" property="name">
                {item.label}
              </span>
              <meta property="position" content={String(index + 2)} />
            </li>
          )
        })}
      </ol>
    </div>
  )
}

export default BreadcrumbComponent
